// extracted by mini-css-extract-plugin
export default {"footerRoot":"Footer_footerRoot__YFGbu","text":"Footer_text__91bxF"};